import React from 'react';

type Props = {
  markSize?: number;
  withName?: boolean;
  className?: string;
};

export const LogoMark = ({ size = 36 }: { size?: number }) => (
  <svg
    className="logo-mark"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
  >
    <rect x="2" y="2" width="60" height="60" rx="16" fill="#101018" />
    <rect
      x="2.6"
      y="2.6"
      width="58.8"
      height="58.8"
      rx="15.4"
      stroke="#a78bfa"
      strokeOpacity="0.9"
      strokeWidth="1.2"
    />
    <path
      d="M16.8 46.2V17.8L29.2 37.6L38.2 18.4"
      stroke="#f4f4f7"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.2 18.4c10.8-1.4 17.6 6.8 16.6 15.4-1.1 9.2-8.6 13.8-16.6 13"
      stroke="#a78bfa"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
    <path
      d="M38.4 32.6H54"
      stroke="#a78bfa"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo: React.FC<Props> = ({
  markSize = 36,
  withName = true,
  className = '',
}) => (
  <span className={`logo ${withName ? '' : 'is-mark'} ${className}`.trim()}>
    <LogoMark size={markSize} />
    {withName ? (
      <span className="logo-word">
        Mustafa Gürses<span>.</span>
      </span>
    ) : null}
  </span>
);

export const LogoLockup: React.FC = () => (
  <div className="about-brand">
    <LogoMark size={96} />
    <div className="about-brand-copy">
      <p className="eyebrow">Hakkımda</p>
      <p className="about-brand-name">
        Mustafa Gürses<span>.</span>
      </p>
      <p className="about-brand-role">Full Stack Developer · Gaziantep</p>
    </div>
  </div>
);
